import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerfomance = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.68243 1.05209C8.25656 0.498142 6.68355 0.451399 5.2273 0.919701C3.77105 1.388 2.52015 2.34286 1.68443 3.62409C0.848716 4.90532 0.479031 6.43497 0.637395 7.95645C0.795758 9.47793 1.47254 10.8987 2.55419 11.9803C3.63585 13.062 5.05659 13.7388 6.57807 13.8971C8.09954 14.0555 9.6292 13.6858 10.9104 12.8501C12.1917 12.0144 13.1465 10.7635 13.6148 9.30721C14.0831 7.85096 14.0364 6.27796 13.4824 4.85209",
			stroke: "#5583F6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.28255 8.58464C8.01893 8.58464 8.61589 7.98768 8.61589 7.2513C8.61589 6.51492 8.01893 5.91797 7.28255 5.91797C6.54617 5.91797 5.94922 6.51492 5.94922 7.2513C5.94922 7.98768 6.54617 8.58464 7.28255 8.58464Z",
			stroke: "#5583F6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.21484 6.31927L11.9482 2.58594",
			stroke: "#5583F6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPerfomance;
